import { Record } from "../../../../../../../records/server/crud";

export class MachineConfigurationTypeInfoProgressiveGamesComponentController {
  static $inject = [];
  constructor() {}

  /*bindings*/
  progressiveGames!: Record[];
  /*end bindings*/
}
